import { FamilyPermittedFunctions } from "@/commons/services/Families";

/**
 * 利用者
 */
export default interface Resident {
  /** 利用者または家族の誕生日(YYYYMMDDhhmmssSSS) */
  birthday: any;
  /** 論理削除フラグ */
  deleteFlag: boolean;
  /** 施設を示す ID */
  facilityId: number;
  /** 性別 */
  gender: string;
  /** 登録日時(YYYYMMDDhhmmssSSS) */
  created?: number | string;
  /** 更新日時(YYYYMMDDhhmmssSSS) */
  updated?: number | string;
  /** パスワード */
  password?: string;
  /** 利用者ID */
  id: number;
  /** 利用者名 */
  name: string;
  /** 利用者名（ふりがな） */
  kanaName: string;
  /** 電話番号 */
  tel: string;
  /** 部屋名 */
  roomId: number;
  /** 部屋名 */
  room: string;
  /** 有効期限(YYYYMMDDhhmmssSSS) */
  validPeriodTo: number;
  /** 家族を示すID */
  familyId?: number;
  /** 家族の氏名 */
  familyName?: string;
  /** 家族の電話番号 */
  familyTel?: string;
  /** LINEのID */
  familyLineId?: string;
  /** 家族の生年月日 正しくはfamilyBirthdayだが、許容する */
  familyBirthDay?: number;
  /** 家族の性別 */
  familyGender?: string;
  /** 続柄 */
  familyRelation?: string;
  /** 家族の役割 */
  familyPosition?: string;
  /** 家族数 */
  familyCount: number;
  /** 家族のメッセージ最終投稿日時(YYYYMMDDhhmmssSSS) */
  familyMessageLatestDate?: number;
  /** 家族の最終投稿メッセージ内容（テキスト） */
  familyLatestMessage?: string;
  /** 送信種別 */
  senderType: SenderType;
  /** 家族のメールアドレス */
  familyMailaddress?: string;
  /** 家族の機能使用可否 */
  familyPermittedFunctions: FamilyPermittedFunctions;
  /** ソートキー (residentId)_(familyId) */
  residentsSortKey?: string;
  /** グループID */
  groupId?: number;

  /** 画面のみで使用する、利用者にひもづく家族 */
  families?: Array<Resident>;
}

export enum SenderType {
  /** LINE */
  LINE = 0,
  /** MAIL */
  MAIL = 1
}
